import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AutoRegistrationTopBarComponent } from 'src/app/shared/auto-registration-top-bar/auto-registration-top-bar.component';
import { VideoComponent } from 'src/app/shared/video/video.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
import { ComponentBase } from 'src/app/core';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [CommonModule, TranslateModule, AutoRegistrationTopBarComponent],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss',
})
export class TermsConditionsComponent extends ComponentBase {
  @Output() closeTerms = new EventEmitter<void>();
  /** Current UI direction (ltr/rtl) from locale */
  dir: string = localStorage.getItem('lang') || '';

  constructor(
    private readonly dialog: MatDialog,
    private readonly translateService: TranslateService,
  ) {
    super();
    translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => {
        this.dir = _.lang;
      });
  }
  /** Opens the video modal in a dialog */
  onOpenVideo(): void {
    this.dialog.open(VideoComponent, {
      minWidth: '60%',
      maxWidth: '100%',
      panelClass: 'aspect_ratio',
    });
  }

  onCloseTermsSidenav(): void {
    this.closeTerms.emit();
  }
}
